<template>
  <form class="form-horizontal" @submit.prevent="updatePassword">
    <div class="row">
      <label class="col-sm-2 col-form-label">Update Password
      </label>
      <div class="col-sm-6">
        <div class="form-group">
          <input type="password" placeholder="Must be atleast 6 charecters long" class="form-control" required v-model.trim="password">
          <span class="form-text">Enter the new password if you want to update it for the client and after updating, provide the new password to the client.</span>
        </div>
      </div>
      <div class="col-sm-4">
        <button class="btn btn-danger mt-0 text-white" :disabled="!password">Update Password</button>
      </div>
    </div>
  </form>
</template>

<script>
import { functions } from "@/firebase/init";

export default {
  name: "PasswordUpdate",
  computed: {
    custID() {
      return this.$store.getters["customer/id"];
    },
    docID() {
      return this.$store.getters["customer/docID"];
    }
  },
  data() {
    return {
      password: null
    };
  },
  methods: {
    updatePassword() {
      // Check if the password is filled
      if (this.password) {
        // Check if the password is atleast 6 charecters long else show error
        if (this.password.length > 5) {
          // Now we have a eligible password to be updated in the firebase auth
          // Set asyncDone to false
          this.$store.dispatch("async/stateUpdate", { state: false });

          // Call firebase cloud function updateAuthPassword to update the password to firebase auth
          // Pass firebase auth user uid and newPassword
          // const updateAuthPassword = functions.httpsCallable(
          //   "updateAuthPassword"
          // );
          //
          // updateAuthPassword({
          //   uid: this.docID,
          //   newPassword: this.password
          // })
          this.$http.post("/auth/update-auth-password", {
            uid: this.docID,
            newPassword: this.password,
            grant_type: 'token',
          })
            .then(result => {
              if (result.data.success) {
                // Set asyncDone to true
                this.$store.dispatch("async/stateUpdate", { state: true });

                this.$store.commit('customer/lastPasswordResetMutate', result.data.lastPasswordResetDate);

                this.password = null;

                // Show success alert for 8 seconds
                this.$store.dispatch("alert/update", {
                  type: "success",
                  message: `The password for the Customer (Cust ID#: ${
                    this.custID
                  }) has successfully been updated. Please provide this new password to the customer for login.`,
                  show: true
                });

                setTimeout(() => {
                  this.$store.dispatch("alert/showUpdate", { show: false });
                }, 8000);
              }
            })
            .catch(err => {
              // Set asyncDone to true
              this.$store.dispatch("async/stateUpdate", { state: true });

              this.password = null;

              // Show error alert for 5 sec
              this.$store.dispatch("alert/update", {
                type: "danger",
                message: err,
                show: true
              });

              setTimeout(() => {
                this.$store.dispatch("alert/showUpdate", { show: false });
              }, 5000);
            });
        } else {
          this.password = null;

          // Show error alert for 5 sec
          this.$store.dispatch("alert/update", {
            type: "danger",
            message: "The password must needs to be 6 chaarecters long",
            show: true
          });

          setTimeout(() => {
            this.$store.dispatch("alert/showUpdate", { show: false });
          }, 5000);
        }
      } else {
        this.password = null;

        // Show error alert for 5 sec
        this.$store.dispatch("alert/update", {
          type: "danger",
          message: "Please enter a password before trying to update it",
          show: true
        });

        setTimeout(() => {
          this.$store.dispatch("alert/showUpdate", { show: false });
        }, 5000);
      }
    }
  }
};
</script>
